// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__ccLgq","overflowing":"ReadFullNote_overflowing__MlkLg"};